import common from "./common";
import nav from "./nav";
import hero from "./hero";
import servers from "./servers";
import vip from "./vip";
import kits from "./kits";
import howto from "./howto";
import discord from "./discord";
import footer from "./footer";
import intro from "./intro";
import login from "./login";
import account from "./account";
import auth from "./auth";
import simulator from "./simulator";
import benefits from "./benefits";
import zaro from "./zaro";
import admin from "./admin";

const NAMESPACES = [
    common, nav, hero, servers, vip, kits, howto, discord, footer, intro, login, account, auth,
    simulator, benefits, zaro, admin,
];

/** Dicionários planos por idioma, juntando todas as secções. */
export const messages = {
    pt: Object.assign({}, ...NAMESPACES.map((n) => n.pt)),
    en: Object.assign({}, ...NAMESPACES.map((n) => n.en)),
};
